import { render } from "./deals-section.vue?vue&type=template&id=03c3bc68"
import script from "./deals-section.vue?vue&type=script&lang=js"
export * from "./deals-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__